
import { Routes, Route } from 'react-router-dom';
import { RequireRole } from '../components/shared/RequireRole';
import { MainLayout } from '../components/layout/MainLayout';
import { AdminLandingPage } from '../features/admin/AdminLandingPage';
import { CreateBrgPage } from '../features/admin/CreateBrgPage';
import { EditBrgPage } from '../features/admin/EditBrgPage';
import { MembersPage } from '../features/admin/MembersPage';
import { BudgetRequestPage } from '../features/shared/BudgetRequestPage';
import { BudgetDashboard } from '../features/shared/BudgetDashboard';
import RecognitionRequestsPage from '../features/admin/RecognitionRequestsPage';
import { OkrsPage } from '../features/admin/OkrsPage';

export function AdminRoutes() {
  return (
    <RequireRole role="BRG-Lead">
      <Routes>
        <Route
          index
          element={
            <MainLayout>
              <AdminLandingPage />
            </MainLayout>
          }
        />
        <Route
          path="brgs/new"
          element={
            <MainLayout>
              <CreateBrgPage />
            </MainLayout>
          }
        />
        <Route
          path="brgs/:id/edit"
          element={
            <MainLayout>
              <EditBrgPage />
            </MainLayout>
          }
        />
        <Route
          path="members"
          element={
            <MainLayout>
              <MembersPage />
            </MainLayout>
          }
        />
         <Route
          path="budget"
          element={
            <MainLayout>
              <BudgetDashboard />
            </MainLayout>
          }
        />
        <Route
          path="budgets/request"
          element={
            <MainLayout>
              <BudgetRequestPage />
            </MainLayout>
          }
        />
        <Route
          path="recognition-requests"
          element={
            <MainLayout>
              <RecognitionRequestsPage />
            </MainLayout>
          }
        />
        <Route
          path="okr-goals"
          element={
            <MainLayout>
              <OkrsPage />
            </MainLayout>
          }
        />
      </Routes>
    </RequireRole>
  );
}
